
import VueMultiSelect from 'vue-multiselect'

export default {
    components: { VueMultiSelect },
    props: {
        value: {
            type: null,
            default: null,
        },
        options: {
            type: Array,
            default: () => {
                return []
            },
        },
        disabled: Boolean,
        placeholder: {
            type: String,
            default: 'Add a Guest',
        },
    },

    methods: {
        closeSelect() {
            this.$refs.multiselect.search = null
        },
    },
}
